import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW4401Component } from './kymw4401.component';
import { CopyPageInfoService } from './api-services/copy-page-info.service';
import { GetMediumListService } from '../../../commons/kymw02/api-services/get-medium-list.service';

/**
 * コピー設定画面 モジュール設定クラス
 *
 * @export KYMW4401Module
 * @class KYMW4401Module
 */
@NgModule({
  imports: [CommonModule, FormsModule, PlessSharedModule, AppCommonsModule],
  declarations: [KYMW4401Component],
  providers: [CopyPageInfoService, GetMediumListService],
})
export class KYMW4401Module {}
